import { type RouteConfig } from 'vue-router'

export const NotificationsTopicsRouter: RouteConfig[] = [
  {
    path: '/notificationstopics',
    component: async () => import('./NotificationsTopics.vue'),
  },
]
